import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./views/Dashboard";
import Maps from "./views/Maps";
import Courses from "./views/Courses";
import Login from "./views/Login";
import Landing from "./views/Landing";
import PlanSelection from "./views/PlanSelection";
import { Fragment, useEffect } from "react";
import Navigation from "./layout/Navigation";
import { useContext } from "react";
import { Context } from "./context/AuthContext";
import Subscribe from "./views/Subscribe";
import useWebSocketStore from "./services/webSocket.service";
import { Conversation } from "./services/chat.service";
import Conversations from "./components/controls/Conversations/Conversations";
import RedeemCode from "./views/redeemFlow/RedeemCode";
import { AppState } from "./appState";
import CancelSubscription from "./views/CancelSubscription";

const AppRouter = () => {
  const user = useContext(Context);
  const connect = useWebSocketStore((state: any) => state.connect);

  const showNavigation = AppState((state) => state.showNavigation);
  const showConversations = AppState((state) => state.showConversations);

  let socket: any;

  useEffect(() => {
    if (!socket) {
      user?.user?.getIdToken().then((result) => {
        localStorage.setItem("ffftoken", result);
        localStorage.setItem("fffuser", user?.user?.uid);
        socket = connect(result, user?.user?.uid);
      });
    }
    return () => {
      socket?.disconnect();
    };
  }, [connect, user?.user]);

  return (
    <Router>
      <Fragment>
        {!!user?.user && !!showNavigation && <Navigation />}
        {!!user?.user && !!showConversations && <Conversations />}
        <Routes>
          {/* Landing page - entry point for new visitors */}
          <Route path="/" element={<Landing />} />
          {/* Auth pages */}
          <Route path="/login" element={<Login />} />
          {/* Plan selection - shown after login/signup */}
          <Route path="/select-plan" element={<PlanSelection />} />
          {/* Redeem code flow (existing) */}
          <Route path="/redeem-code" element={<RedeemCode />} />
          <Route path="/cancel-subscription" element={<CancelSubscription />} />
          {/* Catch-all: send to select-plan for authenticated, landing for unauthenticated */}
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </Fragment>
    </Router>
  );
};

export default AppRouter;
